import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="clipboard"
export default class extends Controller {
  static targets = ["source", "label", "confirmation", "iconCopy", "iconSuccess"];
  static values = { text: String };

  async copy(event) {
    event.preventDefault();
    const text = this.hasSourceTarget
      ? this.sourceTarget.textContent.trim()
      : this.textValue;

    if (!text) return;

    try {
      await navigator.clipboard.writeText(text);
    } catch (error) {
      console.error("Clipboard API failed:", error);
      this.fallbackCopy(text);
    }

    if (this.hasLabelTarget) {
      const original = this.labelTarget.textContent;
      this.labelTarget.textContent = "Copié !";
      setTimeout(() => {
        this.labelTarget.textContent = original;
      }, 2000);
    }

    if (this.hasIconCopyTarget && this.hasIconSuccessTarget) {
      this.iconCopyTarget.classList.add("hidden");
      this.iconSuccessTarget.classList.remove("hidden");
      setTimeout(() => {
        this.iconCopyTarget.classList.remove("hidden");
        this.iconSuccessTarget.classList.add("hidden");
      }, 2000);
    }

    if (this.hasConfirmationTarget) {
      this.confirmationTarget.classList.remove("hidden");
      setTimeout(() => {
        this.confirmationTarget.classList.add("hidden");
      }, 3000);
    }
  }

  fallbackCopy(text) {
    const textarea = document.createElement("textarea");
    textarea.value = text;
    textarea.setAttribute("readonly", "");
    textarea.style.position = "fixed";
    textarea.style.left = "-9999px";
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand("copy");
    document.body.removeChild(textarea);
  }
}
